import { render, staticRenderFns } from "./ProcessTaskView.vue?vue&type=template&id=5389f02f&scoped=true&"
import script from "./ProcessTaskView.vue?vue&type=script&lang=js&"
export * from "./ProcessTaskView.vue?vue&type=script&lang=js&"
import style0 from "./ProcessTaskView.vue?vue&type=style&index=0&id=5389f02f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5389f02f",
  null
  
)

export default component.exports